// columnDefs : headerName, field, sortable, filter, resizable, pinned, width,
//              flex, editable, singleClickEdit, cellEditor, checkboxSelection,
//              headerCheckboxSelection

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { PrintButton } from "../components";
import { useRef, useState } from "@/common/hooks";
import { scrollToTop } from "@/utils/Utilities";

const AgGrid = ({
  mainClassNames = "",
  wrapperClassNames = "",
  printClassNames = "",
  agGridClassNames = "",
  rowData = [],
  columnDefs = [],
  domLayout = "autoHeight",
  onGridReady = () => {},
  pagination = false,
  paginationPageSize = 1,
  rowSelection = "single",
  rowHeight = 50,
  headerHeight = 60,
  onCellClicked = () => {},
  onRowSelected = () => {},
  onCellValueChanged = () => {},
  onSelectionChanged = () => {},
  onFirstDataRendered = () => {},
  onRowClicked = () => {},
  onCellEditingStarted = () => {},
  onCellEditingStopped = () => {},
  singleClickEdit = true,
  suppressClickEdit = false,
  stopEditingWhenCellsLoseFocus = true,
  enterMovesDown = true,
  enterMovesDownAfterEdit = true,
  overlayLoadingTemplate = "<span>Loading...</span>",
  overlayNoRowsTemplate = "<span>No Data</span>",
  loading = false,
  getRowClass = "",
  defaultColDef = {},
  showPrintTable = true,
  children,
  getRowId,
}) => {
  const defaultCol = {
    suppressSizeToFit: true,
    resizable: false,
    sortable: true,
    flex: 1,
    suppressMovable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    wrapText: true,
    autoHeight: true,
    unSortIcon: true,
    ...defaultColDef,
  };

  const [printMode, setPrintMode] = useState(false);
  const agRef = useRef(null);
  const tef = useRef(null);

  const wrapper = () => {
    const wrapper = document.createElement("span");
    wrapper.style.opacity = "0.6";
    wrapper.style.display = "inline-flex";
    wrapper.style.flexDirection = "column";

    return wrapper;
  };

  const icons = {
    sortAscending: () => {
      const el = document.createElement("span");
      el.className = "material-icons sort-icon";
      el.innerText = "arrow_drop_up";
      const wrap = wrapper();
      wrap.appendChild(el);
      return wrap;
    },
    sortDescending: () => {
      const el = document.createElement("span");
      el.className = "material-icons sort-icon";
      el.innerText = "arrow_drop_down";
      const wrap = wrapper();
      wrap.appendChild(el);
      return wrap;
    },
    sortUnSort: () => {
      const wrap = wrapper();
      const up = document.createElement("span");
      up.className = "material-icons sort-icon";
      up.innerText = "arrow_drop_up";
      up.style.marginBottom = "-15px";

      const down = document.createElement("span");
      down.className = "material-icons sort-icon";
      down.innerText = "arrow_drop_down";
      wrap.appendChild(up);
      wrap.appendChild(down);
      return wrap;
    },
  };

  const rootMainClass =
    mainClassNames && mainClassNames.trim() !== ""
      ? mainClassNames
      : "d-none d-lg-block";

  const onPaginationChanged = () => {
    if (pagination) scrollToTop();
  };

  return (
    <>
      <div className={rootMainClass}>
        {showPrintTable && rowData && rowData.length ? (
          <PrintButton
            label="Print Table"
            wrapperClassName={`mb-1 ${printClassNames}`}
            agRef={agRef}
            click={(val) => setPrintMode(val)}
          />
        ) : (
          ""
        )}
        <div
          className={`AgGrid d-print-block ${wrapperClassNames}`}
          style={{ width: "100%", overflow: "auto" }}
          ref={agRef}
        >
          <AgGridReact
            ref={tef}
            className={`ag-theme-alpine ${agGridClassNames} ${
              rowData && rowData.length < 3 ? "h-200" : ""
            }`}
            getRowId={getRowId}
            rowData={rowData}
            columnDefs={columnDefs}
            domLayout={printMode ? "print" : domLayout}
            defaultColDef={defaultCol}
            onGridReady={onGridReady}
            pagination={pagination}
            paginationPageSize={paginationPageSize}
            rowSelection={rowSelection}
            animateRows={false}
            rowHeight={rowHeight}
            headerHeight={headerHeight}
            suppressRowClickSelection={true}
            onCellClicked={onCellClicked}
            onRowSelected={onRowSelected}
            onCellValueChanged={onCellValueChanged}
            onSelectionChanged={onSelectionChanged}
            onCellEditingStarted={onCellEditingStarted}
            onCellEditingStopped={onCellEditingStopped}
            onFirstDataRendered={onFirstDataRendered}
            onRowClicked={onRowClicked}
            deltaRowDataMode={false}
            overlayLoadingTemplate={overlayLoadingTemplate}
            overlayNoRowsTemplate={overlayNoRowsTemplate}
            loading={loading}
            getRowClass={getRowClass}
            tooltipShowDelay={0}
            icons={icons}
            singleClickEdit={singleClickEdit}
            suppressClickEdit={suppressClickEdit}
            stopEditingWhenCellsLoseFocus={stopEditingWhenCellsLoseFocus}
            enterMovesDown={enterMovesDown}
            enterMovesDownAfterEdit={enterMovesDownAfterEdit}
            onPaginationChanged={onPaginationChanged}
          />
          {children}
        </div>
      </div>
    </>
  );
};

export default AgGrid;
